import Vue from "vue";
import Vuex from "vuex";
import product from "./product";
import newProduct from "./newProduct";
import insure from "./insure";
import user from "./user";
import axios from "../plugins/axios";
import validate from "@/assets/js/validate";

Vue.use(Vuex);

const storageTokenKey = "api_token";
const storageLoginKey = "app_login";
const qihuibaoInfo = "userInfo";

export default new Vuex.Store({
  state: {
    token: "",
    loginVisible: false,
    loginStatus: false,
    enums: {}
  },
  getters: {
    getEnum: state => key => {
      return state.enums[key];
    }
  },
  mutations: {
    setLogin(state, data) {
      this.commit("setToken", data.token);
      if (data.token) {
        state.loginStatus = true;
        localStorage.setItem(storageLoginKey, "1");
        localStorage.setItem(qihuibaoInfo, JSON.stringify(data));
      } else {
        state.loginStatus = false;
        localStorage.removeItem(storageLoginKey);
        localStorage.removeItem(qihuibaoInfo);
        localStorage.removeItem(storageTokenKey);
      }
    },
    setToken(state, token) {
      state.token = token;
      localStorage.setItem(storageTokenKey, token);
      // 检测是否已登录了（刷新页面后要设置登录状态）
      const loginStatus = localStorage.getItem(storageLoginKey);
      if (loginStatus === "1") {
        state.loginStatus = true;
      }
    },
    setLoginVisible(state, val) {
      state.loginVisible = val;
    },
    setEnums(state, val) {
      state.enums = val;
    }
  },
  actions: {
    getEnums({ commit, state }) {
      return new Promise(resolve => {
        if (state.enums && Object.keys(state.enums).length > 0) {
          resolve(state.enums);
        } else {
          this.$axios.get("/json/enums.json").then(data => {
            commit("setEnums", data);
            resolve(data);
          });
        }
      });
    },
    getToken({ commit }) {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem(storageTokenKey);
        if (token) {
          resolve(token);
        } else {
          this.$axios
            .post("/app/api/token/getBaseToken", {
              appId: process.env.VUE_APP_Id,
              appTypeId: "1",
              timestamp: Date.now()
            })
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              console.log("获取token异常！", err);
              reject();
            });
        }
      }).then(token => {
        commit("setToken", token);
      });
    },
    // 呼出登录框
    callLogin({ commit }) {
      commit("setLoginVisible", true);
    },
    login({ commit, dispatch }, form) {
      // npm package: qs 可以进行 form 和 json 数据转换
      return new Promise((resolve, reject) => {
        let url = "/app/api/account/doLogin"
        if (!validate.isMobilePhone(form.loginName)){
          url = "/app/api/heshunbao/doLogin"
        }
        this.$axios
          .post(url, form)
          .then(res => {
            if (res.code === 200) {
              // 登录成功
              commit("setLogin", res.data); // 更新为登录token
              dispatch("getUserInfo");
              resolve();
            } else {
              reject(res.message);
            }
          })
          .catch(err => {
            reject(err.message);
          });
      });
    },
    logout({ commit, dispatch }) {
      return new Promise(resolve => {
        commit("setLogin", "");
        dispatch("getToken");
        resolve();
      });
    }
  },
  modules: {
    product,
    insure,
    user,
    newProduct
  },
  plugins: [
    // vuex 集成 $axios
    store => {
      store.$axios = axios;
    }
  ]
});
